'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { Component } from 'react';
import ViewContainerDecorator from 'documents-lib/js/decorators/ViewContainerDecorator';
import ViewContainer from 'documents-lib/js/containers/ViewContainer';
import UIFloatingAlertList from 'UIComponents/alert/UIFloatingAlertList';
import * as DocumentsPublicActions from '../actions/DocumentsPublicActions';
import * as PublicViewerActions from '../actions/PublicViewerActions';
const ViewComponent = ViewContainerDecorator(ViewContainer, {
  isPreview: false,
  documentActions: DocumentsPublicActions,
  hasHigherDocumentsLimit: undefined,
  publicViewerActions: PublicViewerActions
});

class ViewApplication extends Component {
  render() {
    const [__string, presentationId] = window.location.pathname.match(/\/documents\/\d+\/view\/(\d+)/); // Mimic how Router sets up params

    const match = {
      params: {
        presentationId
      }
    };
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(ViewComponent, {
        match: match
      }), /*#__PURE__*/_jsx(UIFloatingAlertList, {})]
    });
  }

}

export default ViewApplication;